<template>
  <div class="body_center_left_comment_details_speak" v-if="!commentList.replyComment">
    <div>
      <div class="body_center_left_comment_details_speak_user_img"><img :src="commentList.creator.avatar"></div>
      <div class="body_center_left_comment_details_speak_user_name">{{commentList.creator.nickname}}</div>
    </div>
    <div class="comment_details_content">
      <div class="comment_details_content_msg">{{commentList.content}}</div>
      <div class="comment_details_content_div">
        <div class="comment_details_content_bnt" @click="replyFun()">返信</div>
        <div class="comment_details_content_time">{{timeToStr(commentList.createdDate)}}</div>
        <div class="comment_details_content_like" @click="likeFun(commentList)">
          <div class="comment_details_content_like_img">
            <img src="@/assets/imgs/article_like.png" v-if="!commentList.like" />
            <img src="@/assets/imgs/article_like_click.png" v-else/>
          </div>
          <div class="comment_details_content_like_msg">
            {{commentList.likeNum}}
          </div>
        </div>
      </div>
      <div class="comment_details_reply" v-if="replyState">
        <div>
          <el-input
            height="91px"
            type="textarea"
            resize="none"
            :rows="3"
            maxlength="75"
            :placeholder="commentList.creator.nickname+':'"
            v-model="reply">
          </el-input>
        </div>
        <div style="height: 23px;margin: 10px 0">
          <div class="comment_details_reply_btn" @click="replyCommentFun()">送信</div>
        </div>
      </div>
      <div class="comment_details_content_speak" v-loading="childLoading" v-for="(items,index) in childList" :key="index">
        <div>
          <div class="comment_details_content_speak_user_img"><img :src="items.creator.avatar"></div>
          <div class="comment_details_content_speak_user_name">{{items.creator.nickname}}</div>
        </div>
        <div class="comment_details_content_speak_content">
          <div class="comment_details_content_speak_content_msg">{{items.content}}</div>
          <div class="comment_details_content_div2">
            <div class="comment_details_content_time">{{timeToStr(items.createdDate)}}</div>
            <div class="comment_details_content_like" @click="likeFun(items)">
              <div class="comment_details_content_like_img">
              <img src="@/assets/imgs/article_like.png" v-if="!items.like" />
              <img src="@/assets/imgs/article_like_click.png" v-else/>
              </div>
              <div class="comment_details_content_like_msg">
                {{items.likeNum}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as json from '@/assets/js/json'
  import { timeToStr } from '@/assets/js/util'
  export default {
    props:{
      commentList:{
        type: Object,
        default: () => {
          return {}
        }
      },
      isArticle:{
        type: Boolean,
        default: () => {
          return true
        }
      }
    },
    data() {
      return {
        replyState: false,
        childList: [],
        childLoading: true,
        reply: null,
      }
    },
    watch:{
      commentList(newVal,oldVal){
        this.getChildList()
      }
    },
    created () {
      this.getChildList()
    },
    methods: {
      getChildList(){
        if(this.isArticle){
          let option = {
            size : 6,
            current : 1,
            articleCommentId : this.commentList.id
          }
          this.childLoading = true
          json.post('/api/member/article/comment/child/list',option).then(res =>{
            if(res.data.success){
              this.childList = res.data.data.commentChild
              this.childLoading = false
            }
          })
        }else{
          let option = {
            size : 6,
            current : 1,
            PostCommentId : this.commentList.id
          }
          this.childLoading = true
          json.post('/api/member/post/comment/child/list',option).then(res =>{
            if(res.data.success){
              this.childList = res.data.data.page.records
              this.childLoading = false
            }
          })
        }
        
      },
      replyCommentFun(){
        if(this.isArticle){
          let option = {
            content : this.reply,
            articleId : this.$parent.article.id,
            replyId : this.commentList.id
          }
          this.childLoading = true
          json.post('/api/member/article/comment/add',option).then(res =>{
            if(res.data.success){
              this.reply = null
              this.replyFun()
              this.getChildList()
              this.$parent.article.commentNum++
              this.childLoading = false
            }
          })
        }else{
          let option = {
            content : this.reply,
            postId : this.$parent.post.id,
            replyId : this.commentList.id
          }
          this.childLoading = true
          json.post('/api/member/post/comment/add',option).then(res =>{
            if(res.data.success){
              this.reply = null
              this.replyFun()
              this.getChildList()
              this.$parent.post.commentNum++
              this.childLoading = false
            }
          })
        }
      },
      timeToStr (val) {
        // return timeToStr(val)
        const date = new Date(val); // 根据时间戳创建Date对象
        const year = date.getFullYear(); // 获取年份
        const month = date.getMonth() + 1; // 获取月份，需要加1
        const day = date.getDate(); // 获取日期
        const hour = date.getHours(); // 获取小时
        const minute = date.getMinutes(); // 获取分钟
        const second = date.getSeconds(); // 获取秒数
        const formattedDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`
        return formattedDate
      },
      replyFun(){
        if(!this.$store.state.userInfo||!this.$store.state.token){
          this.$parent.loginResFun()
          return
        }
        if(this.replyState){
          this.replyState = false
        }else{
          this.replyState = true
        }
      },
      likeFun(commentList){
        if(!this.$store.state.userInfo||!this.$store.state.token){
          this.$parent.loginResFun()
          return
        }
        this.$parent.likeFun(commentList)
        setTimeout(() => {
          this.getChildList()
        }, 1000);
        
      }
    },
  }
</script>

<style  scoped>
  @import 'index.css';
</style>